export const clearMantyGraphQueryApiServiceWorkerCache = () => {
    if ('serviceWorker' in navigator) {
        caches.delete('manty-graph-query-api-cache');
    }
};
